export function isMobileDevice(): boolean {
  return /iPhone|Android/i.test(navigator.userAgent)
}
